import React, { Fragment, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import EditMyProfile from "./EditmyProfile";
import MyProfileEdit from "./MyProfile";
import TableSettings from "./tableSettings";

const UsersEditContain = () => {
  const logger = React.useContext(LoggerContext);

  useEffect(() => {
    logger.log(LogEvents.myProfile, {});
  }, []);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="User Edit" parent="Users" title="User Edit" />
      <Container fluid={true}>
        <div className="edit-profile">
          <Row>
            <Col xl="4">
              <MyProfileEdit />
            </Col>
            <Col xl="8">
              <EditMyProfile />
            </Col>
          </Row>
        </div>
        {/* <TableSettings/> */}
      </Container>
    </Fragment>
  );
};
export default UsersEditContain;
